export enum ActiveValue {
  EMPLOYEE_ACTIVE = "Active",
  EMPLOYEE_DE_ACTIVATED = "De-activated",
}
